const pageNameKey = "twoFactorAuthenticationButtonsWrapper";

export const twoFactorAuthenticationButtonsWrapperEn = {
  [pageNameKey]: {
    resendEmailSuccess:
      "You successfully sent the invitation email to this user.",
    resendEmailError: "Failed to resend email, please try again later.",
    remove2FASuccess: "You successfully removed 2FA for this user.",
    remove2FAError: "Failed to remove 2FA, please try again later.",
    manageTwoFactorAuthenticationLabel: "Manage Two-Factor Authentication",
    bothOptionsActiveText:
      "Send a new invitation email for this user or remove the current 2FA option.",
    removeTwoFactorAuthenticationText:
      "Remove the Two-Factor Authentication method for this user",
    resendEmailButtonText: "Resend Email",
    remove2FAButtonText: "Remove 2FA",
  },
};

export const twoFactorAuthenticationButtonsWrapperPtBr = {
  [pageNameKey]: {
    resendEmailSuccess:
      "Você enviou com sucesso o e-mail de convite para este usuário.",
    resendEmailError: "Falha ao reenviar o e-mail. Tente novamente mais tarde.",
    remove2FASuccess:
      "Você removeu a autenticação de dois fatores deste usuário com sucesso.",
    remove2FAError:
      "Falha ao remover a autenticação em dois fatores. Tente novamente mais tarde.",
    manageTwoFactorAuthenticationLabel:
      "Gerenciar autenticação de dois fatores",
    bothOptionsActiveText:
      "Envie um novo e-mail de convite para este usuário ou remova a opção atual de 2FA.",
    removeTwoFactorAuthenticationText:
      "Remover o método de autenticação de dois fatores para este usuário",
    resendEmailButtonText: "Reenviar e-mail",
    remove2FAButtonText: "Remover 2FA",
  },
};

export const twoFactorAuthenticationButtonsWrapperDe = {
  [pageNameKey]: {
    resendEmailSuccess:
      "Sie haben die Einladung E-Mail erfolgreich an diesen Benutzer gesendet.",
    resendEmailError:
      "Fehler beim erneuten Senden der E-Mail, bitte versuchen Sie es später erneut.",
    remove2FASuccess: "Sie haben 2FA für diesen Benutzer erfolgreich entfernt.",
    remove2FAError:
      "Fehler beim Entfernen von 2FA, bitte versuchen Sie es später erneut.",
    manageTwoFactorAuthenticationLabel:
      "Zwei-Faktor-Authentifizierung verwalten",
    bothOptionsActiveText:
      "Senden Sie eine neue Einladung E-Mail für diesen Benutzer oder entfernen Sie die aktuelle 2FA-Option.",
    removeTwoFactorAuthenticationText:
      "Entfernen Sie die Zwei-Faktor-Authentifizierungsmethode für diesen Benutzer",
    resendEmailButtonText: "E-Mail erneut senden",
    remove2FAButtonText: "2FA entfernen",
  },
};

export const twoFactorAuthenticationButtonsWrapperZhHans = {
  [pageNameKey]: {
    resendEmailSuccess: "您已成功向该用户发送邀请电子邮件。",
    resendEmailError: "重新发送电子邮件失败，请稍后再试。",
    remove2FASuccess: "您已成功为该用户删除2FA。",
    remove2FAError: "删除2FA失败，请稍后再试。",
    manageTwoFactorAuthenticationLabel: "管理双因素身份验证",
    bothOptionsActiveText: "为该用户发送新的邀请电子邮件或删除当前的2FA选项。",
    removeTwoFactorAuthenticationText: "删除该用户的双因素身份验证方法",
    resendEmailButtonText: "重新发送电子邮件",
    remove2FAButtonText: "删除2FA",
  },
};

export const twoFactorAuthenticationButtonsWrapperIt = {
  [pageNameKey]: {
    resendEmailSuccess: "Hai inviato l'email di invito a questo utente.",
    resendEmailError: "Impossibile reinviare la mail, riprova più tardi.",
    remove2FASuccess:
      "Hai rimosso con successo il fattore di autenticazione a due fattori per questo utente.",
    remove2FAError:
      "Impossibile rimuovere l'autenticazione a due fattori, riprova più tardi.",
    manageTwoFactorAuthenticationLabel:
      "Gestisci l'autenticazione a due fattori",
    bothOptionsActiveText:
      "Invia una nuova email di invito per questo utente oppure rimuovi l'opzione 2FA attuale.",
    removeTwoFactorAuthenticationText:
      "Rimuovi il metodo di autenticazione a due fattori per questo utente",
    resendEmailButtonText: "Riinvia email",
    remove2FAButtonText: "Disattiva l'2FA",
  },
};

export const twoFactorAuthenticationButtonsWrapperEs = {
  [pageNameKey]: {
    resendEmailSuccess:
      "Has enviado correctamente el correo electrónico de invitación a este usuario.",
    resendEmailError:
      "No se pudo reenviar el correo electrónico, por favor inténtalo de nuevo más tarde.",
    remove2FASuccess:
      "Has eliminado correctamente la autenticación de dos factores de este usuario.",
    remove2FAError:
      "No se pudo eliminar la autenticación en dos factores. Por favor, inténtalo de nuevo más tarde.",
    manageTwoFactorAuthenticationLabel:
      "Administrar la autenticación de dos factores",
    bothOptionsActiveText:
      "Enviar un nuevo correo electrónico de invitación para este usuario o eliminar la opción actual de 2FA.",
    removeTwoFactorAuthenticationText:
      "Eliminar el método de autenticación de dos factores para este usuario",
    resendEmailButtonText: "Reenviar correo electrónico",
    remove2FAButtonText: "Eliminar la autenticación en dos pasos",
  },
};

export const twoFactorAuthenticationButtonsWrapperNl = {
  [pageNameKey]: {
    bothOptionsActiveText:
      "Verstuur een nieuwe uitnodigingsmail voor deze gebruiker of verwijder de huidige 2FA-optie.",
    manageTwoFactorAuthenticationLabel: "Tweefactorauthenticatie beheren",
    remove2FAButtonText: "2FA verwijderen",
    remove2FAError:
      "Fout bij het verwijderen van 2FA. Probeer het later opnieuw.",
    remove2FASuccess: "U heeft 2FA voor deze gebruiker succesvol verwijderd.",
    removeTwoFactorAuthenticationText:
      "Verwijder de tweefactorauthenticatiemethode voor deze gebruiker",
    resendEmailButtonText: "E-mail opnieuw verzenden",
    resendEmailError:
      "Fout bij het opnieuw verzenden van de e-mail. Probeer het later opnieuw.",
    resendEmailSuccess:
      "U heeft de uitnodigingsmail succesvol naar deze gebruiker verzonden.",
  },
};

export const twoFactorAuthenticationButtonsWrapperTr = {
  [pageNameKey]: {
    bothOptionsActiveText:
      "Bu kullanıcıya yeni bir davet e-postası gönderin veya mevcut 2FA seçeneğini kaldırın.",
    manageTwoFactorAuthenticationLabel:
      "İki Faktörlü Kimlik Doğrulamayı Yönetin",
    remove2FAButtonText: "2FA'yı kaldır",
    remove2FAError: "2FA kaldırılamadı. Lütfen daha sonra tekrar deneyin.",
    remove2FASuccess: "Bu kullanıcı için 2FA'yı başarıyla kaldırdınız.",
    removeTwoFactorAuthenticationText:
      "Bu kullanıcı için İki Faktörlü Kimlik Doğrulama yöntemini kaldırın",
    resendEmailButtonText: "E-postayı yeniden gönder",
    resendEmailError:
      "E-posta yeniden gönderilemedi, lütfen daha sonra tekrar deneyin.",
    resendEmailSuccess:
      "Bu kullanıcıya davet e-postasını başarıyla gönderdiniz.",
  },
};
